<template>

    <div v-if="Object.keys(options).length > 1"
         class="variant-select">

        <div class="option-info">
            SELECTED OPTION:
            <span class="option-info-selected">
                {{ selectedOptionName }}
            </span>
        </div>

        <div class="options">
            <div v-for="(values, id) in visibleOptions"
                 class="option-select"
                 :class="{ active: id == selected }"
                 @click="changeVariant(id)">

                <div class="content">
                    {{ formatOptionName(Object.values(values)) }}
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import ApiVariant from '../api/Variant'

    import { flow, toPairs, sortBy, fromPairs } from 'lodash/fp'

    export default {
        name: 'product-options',
        props: {
            options: Object,
            selected: String,
            showPhantoms: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            selectedOptionName() {
                let selected_option = Object.keys(this.options).filter(id => id == this.selected)
                return selected_option.length == 0 ? null : this.formatOptionName(Object.values(this.options[selected_option[0]]))
            },
            visibleOptions () {
                if (this.$store.getters['productData/getGiftCard']) {
                    return flow(
                        toPairs,
                        sortBy(option => parseFloat(option[1].amount.replace('$', ''))),
                        fromPairs
                    )(this.options)
                }

                return this.options
            }
        },
        methods: {
            formatOptionName(options) {
                if (typeof(options) == 'string'){
                    return options
                } else {
                    return options.join(', ')
                }
            },
            fetchApiVariant(id) {
                ApiVariant.getVariant(id, { show_phantoms: this.showPhantoms })
                    .then(response => {
                        this.setVariantFromResponse(id, response)
                    })
                    .catch(error => {
                        if (error?.response?.status === 410) {
                            this.setVariantFromResponse(id, error.response)
                        } else {
                            console.log(error)
                        }
                    })
            },
            setVariantFromResponse (id, response) {
                this.$store.dispatch('productData/addVariant', response.data.data)
                this.$emit('changeVariant', {
                    selectedVariant: id,
                    selectedVariantSlug: this.$store.getters['productData/getSlug'](id)
                })
                this.$emit('loading', false)
            },
            fetchStoreVariant(id) {
                this.$emit('changeVariant', {
                    selectedVariant: id,
                    selectedVariantSlug: this.$store.getters['productData/getSlug'](id)
                })
                this.$emit('loading', false)
            },
            changeVariant(id) {
                if ( this.selected != id ) {
                    this.$emit('loading', true)
                    if ( this.$store.getters['productData/variantExist'](id) ) {
                        console.log("VARIANT - FETCH FROM STORE")
                        this.fetchStoreVariant(id)
                    } else {
                        console.log("VARIANT - FETCH FROM API")
                        this.fetchApiVariant(id)
                    }
                } else {
                    console.log('NOTHING CHANGED')
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/../shared/assets/stylesheets/product-options';
</style>